import {
  deleteMutate,
  postMutate,
  updateMutate,
} from 'utils/customMutation';
import { fetchData } from 'utils/customUseQuery';
import endPoints from 'utils/platformEndPoints/ossix';

export const getUserData = () => {
  const userPID = localStorage.getItem('userPID');
  const { data, isLoading, refetch } = fetchData({
    url: endPoints.GetUserData,
    payload: { PID: userPID },
  });
  return { isLoading, userData: data ?? [], refetch };
};

export const getAllUserContact = () => {
  const { pureData, isPending, isError, isSuccess, message, mutate } =
    postMutate(endPoints.GetSavedGatewayContactList);
  return {
    isLoadingContacts: isPending,
    userContactData: pureData,
    mutate,
    isRequestSavedContactSuccess: isSuccess,
    isRequestSavedContactError: isError,
    requestSavedContactMessage: message,
  };
};

export const getUserContact = (payload: { CountryCode: string }) => {
  const { data, isPending, isError, isSuccess } = fetchData({
    url: endPoints.GetSavedGatewayContactList,
    payload: payload,
    enabled: !!payload.CountryCode,
  });
  return {
    isLoadingContacts: isPending,
    userContactData: data,
    isRequestSavedContactSuccess: isSuccess,
    isRequestSavedContactError: isError,
  };
};

export const saveBankAccountContact = () => {
  const { data, isPending, isError, isSuccess, message, mutate } =
    postMutate(endPoints.SaveBankAccountContact);
  return {
    isRequestLoading: isPending,
    savedUserContactData: data,
    mutate,
    isSaveUserContactSuccess: isSuccess,
    isSaveUserContactError: isError,
    saveUserContactMessage: message,
  };
};

export const requestFetchUserTransactions = (payload: {
  WalletNumber: string;
  PageNumber: string;
  RecordPerPage: string;
  DateFrom: string;
  DateTo: string;
  Proxy: string;
}) => {
  const { data, isPending, isError, isSuccess, error } = fetchData({
    url: endPoints.GetTransaction,
    payload: payload,
  });

  return {
    allTransactionData: data?.[0] ?? [],
    loadTransaction: isPending,
    isTransactionError: isError,
    isTransactionSuccess: isSuccess,
    transactionError: error,
  };
};

export const requestUserTransactions = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.GetTransaction);

  return {
    transactionData: data,
    loadTransaction: isPending,
    isTransactionError: isError,
    isTransactionSuccess: isSuccess,
    transactionMessage: message,
    transactionError: error,
    mutate,
    clearData,
  };
};

export const locateUserAccount = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.LocateWallet);
  return {
    locateUserData: data,
    loadLocateUser: isPending,
    isLocateUserError: isError,
    isLocateUserSuccess: isSuccess,
    locateUserMessage: message,
    locateUserError: error,
    mutate,
    clearData,
  };
};

export const confirmWithPIN = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.CheckUserPIN);
  return {
    checkUSerPINData: data,
    loadCheckUSerPIN: isPending,
    isCheckUSerPINError: isError,
    isCheckUSerPINSuccess: isSuccess,
    checkUSerPINMessage: message,
    checkUSerPINError: error,
    mutate,
    clearData,
  };
};

export const requestCashBack = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.CashBackRequest);
  return {
    cashBackData: data,
    loadCashBack: isPending,
    isCashBackError: isError,
    isCashBackSuccess: isSuccess,
    cashBackMessage: message,
    cashBackError: error,
    mutate,
    clearData,
  };
};

export const uploadSupportedDocument = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.UploadKYCDocs);
  return {
    uploadSupportedDocData: data,
    loadUploadSupportedDoc: isPending,
    isUploadSupportedDocError: isError,
    isUploadSupportedDocSuccess: isSuccess,
    uploadSupportedDocMessage: message,
    uploadSupportedDocError: error,
    mutate,
    clearData,
  };
};

export const requestSaveUserLanguage = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
  } = postMutate(endPoints.SaveUserLanguageChoice);

  return {
    saveLangData: data,
    loadSavedLang: isPending,
    isSaveLanguageError: isError,
    isSaveLangSuccess: isSuccess,
    saveLangResponse: message,
    saveLangError: error,
    requestSaveLang: mutate,
  };
};

export const changeUserPwd = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.ChangeUserPwd);

  return {
    changePWDData: data,
    loadSavedLang: isPending,
    isChangePWDError: isError,
    isChangePWDSuccess: isSuccess,
    changePWDResponse: message,
    changePWDError: error,
    requestChangePWD: mutate,
    clearChangePwdRequest: clearData,
  };
};

export const changeUserPIN = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.ChangeUserPIN);

  return {
    changePINData: data,
    loadSavedPIN: isPending,
    isChangePINError: isError,
    isChangePINSuccess: isSuccess,
    changePINResponse: message,
    changePINError: error,
    requestChangePIN: mutate,
    clearChangePINRequest: clearData,
  };
};

export const updateUserIDdata = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.SaveUserIDdata);

  return {
    updateIDData: data,
    loadSavedID: isPending,
    isChangePINError: isError,
    isChangePINSuccess: isSuccess,
    updateIDResponse: message,
    updateIDError: error,
    requestSavedID: mutate,
    clearSavedIDRequest: clearData,
  };
};

export const updateSaveUserData = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.SaveUserIDdata);

  return {
    updateUserData: data,
    loadUpdateUserData: isPending,
    isUpdateUserDataError: isError,
    isUpdateUserDataSuccess: isSuccess,
    updateUserDataResponse: message,
    updateUserDataError: error,
    requestUpdateUserData: mutate,
    clearupdateUserDataRequest: clearData,
  };
};

export const updateBeneficiary = ({
  benefId,
}: {
  benefId: string | number;
}) => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = updateMutate(
    `${endPoints.UpdateAndRemoveBeneficiary}/${benefId}`,
  );

  return {
    updateBeneficiaryData: data,
    loadUpdateBeneficiary: isPending,
    isUpdateBeneficiaryDataError: isError,
    isUpdateBeneficiaryDataSuccess: isSuccess,
    updateBeneficiaryDataResponse: message,
    updateBeneficiaryDataError: error,
    requestUpdateBeneficiary: mutate,
    clearupdateBeneficiaryDataRequest: clearData,
  };
};

export const deleteBeneficiary = ({
  benefId,
}: {
  benefId: string | number;
}) => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = deleteMutate(
    `${endPoints.UpdateAndRemoveBeneficiary}/${benefId}`,
  );

  return {
    removeBenef: data,
    loadRemoveBenef: isPending,
    isRemoveBenefError: isError,
    isRemoveBenefSuccess: isSuccess,
    removeBenefResponse: message,
    removeBenefError: error,
    requesRemoveBenef: mutate,
    clearRemoveBenefRequest: clearData,
  };
};

export const resetUserPIN = () => {
  const {
    data,
    isPending,
    isError,
    isSuccess,
    message,
    error,
    mutate,
    clearData,
  } = postMutate(endPoints.ResetPasswordPrequalification);

  return {
    resetUserPINData: data,
    loadResetUserPINData: isPending,
    isResetUserPINDataError: isError,
    isResetUserPINDataSuccess: isSuccess,
    resetUserPINDataResponse: message,
    resetUserPINDataError: error,
    requestResetUserPINData: mutate,
    clearresetUserPINDataRequest: clearData,
  };
};
